import React from "react";
import { Button } from "../ui/button";
import { ShoppingBag, Phone } from "lucide-react";
import { RESTAURANT, IMAGES } from "../../lib/restaurantData";
import { useT } from "../../lib/i18n";

export const Asporto = () => {
  const { t } = useT();
  const waMsg = encodeURIComponent(t("whatsappAsporto"));

  return (
    <section id="asporto" data-testid="asporto-section" className="py-20 sm:py-28 bg-[#EDE3D2]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-10 items-stretch rounded-3xl overflow-hidden bg-[#1E3A5D] shadow-2xl">
          <div className="relative min-h-[280px] lg:min-h-[420px]">
            <img src={IMAGES.calzone} alt="" className="absolute inset-0 w-full h-full object-cover opacity-95" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#0E1F35]/65 to-transparent" />
          </div>

          <div className="p-8 sm:p-12 lg:p-16 flex flex-col justify-center text-white">
            <span className="inline-flex items-center gap-2 font-display text-xs tracking-[0.3em] text-[#E8C765] font-semibold">
              <ShoppingBag className="w-4 h-4" /> {t("asporto.eyebrow")}
            </span>
            <h2 className="mt-4 font-script text-6xl sm:text-7xl lg:text-8xl leading-[1] text-white">
              {t("asporto.title")}
            </h2>
            <p className="mt-5 text-white/85 text-base sm:text-lg leading-relaxed max-w-md font-serif-body italic">
              {t("asporto.desc")}
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Button
                asChild
                data-testid="asporto-call-btn"
                className="font-display text-xs tracking-[0.22em] rounded-full bg-[#B59410] hover:bg-[#8E7308] px-7 py-6 font-semibold"
              >
                <a href={RESTAURANT.phoneHref}>
                  <Phone className="w-4 h-4 mr-2" />
                  {t("asporto.call")}
                </a>
              </Button>
              <Button
                asChild
                variant="outline"
                data-testid="asporto-whatsapp-btn"
                className="font-display text-xs tracking-[0.22em] rounded-full border-white/40 bg-transparent text-white hover:bg-white hover:text-[#1E3A5D] px-7 py-6 font-semibold"
              >
                <a
                  href={`https://wa.me/${RESTAURANT.whatsapp}?text=${waMsg}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t("asporto.whatsapp")}
                </a>
              </Button>
            </div>
            <p className="mt-5 text-white/55 text-xs font-serif-body italic">
              {t("asporto.note")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
